import React, { Component } from 'react';
import './App.css';
import { withRouter } from "react-router-dom";
import Home from './pages/home/Home';

class App extends Component {

  state = {
    waitingFor: false
  }

  render() {
    return (
      <div className="App">
        <Home />
      </div>
    );
  }
}

export default withRouter(App);
